var map = {
	"./about-us.png": 8116,
	"./contact-header.jpg": 6534,
	"./error-404.png": 4679,
	"./header.jpg": 8939,
	"./hero-header.jpg": 6460,
	"./instagram.png": 7682,
	"./kathmandu.jpg": 7063,
	"./linkedin.png": 838,
	"./logo-tiktok.svg": 4830,
	"./logo.png": 5549,
	"./man.png": 7526,
	"./not-found.jpg": 5962,
	"./not-found.png": 9934,
	"./tiktok.png": 634,
	"./whatsapp.png": 454
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 970;